import { unitizedPx } from '@badi/badi-components';

export const AVATAR_SIZE = unitizedPx(6);
export const KEY_CODE_ENTER = 13;
export const MAX_MESSAGE_LENGTH = 2000;
